import {query} from 'api';
import PropTypes from 'prop-types';
import Gift from './gift';
import {Hr} from 'ui';
import {
  Section,
  DarkSection,
  SectionTitle,
  DarkSectionTitle,
  GiftSlider,
  MorePointsButton,
} from './styles';

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  variableWidth: true,
  centerMode: false,
};

const GiftsBlock = ({data, userPoints}) => {
  const affordable = data.filter(g => Number(g.acf.cadeaux_points) <= userPoints);
  const unaffordable = data.filter(g => Number(g.acf.cadeaux_points) > userPoints);

  return (
    <>
      {affordable.length > 0 && (
        <>
          <Hr style={{marginBottom: 0}} />
          <Section className="giftsSliderLight">
            <SectionTitle>Commandez votre cadeau</SectionTitle>
            <GiftSlider {...sliderSettings}>
              {affordable.map(giftData => (
                <Gift
                  key={giftData.id}
                  giftId={giftData.id}
                  title={giftData.title.rendered}
                  points={giftData.acf.cadeaux_points}
                  image={giftData.acf.cadeaux_image}
                  subTitle={giftData.acf.cadeaux_sous_titre}
                  affordable
                />
              ))}
            </GiftSlider>
          </Section>
        </>
      )}

      {unaffordable.length > 0 && (
        <>
          <Hr style={{marginBottom: 0}} />
          <DarkSection className="giftsSliderDark">
            <DarkSectionTitle>Il vous manque quelques points pour ces cadeaux</DarkSectionTitle>
            <GiftSlider {...sliderSettings}>
              {unaffordable.map(giftData => (
                <Gift
                  key={giftData.id}
                  giftId={giftData.id}
                  title={giftData.title.rendered}
                  points={giftData.acf.cadeaux_points}
                  image={giftData.acf.cadeaux_image}
                  subTitle={giftData.acf.cadeaux_sous_titre}
                  pointsOnLink={Number(giftData.acf.cadeaux_points) - userPoints}
                  affordable={false}
                />
              ))}
            </GiftSlider>
            <MorePointsButton to="/gifts/more-points">Comment obtenir plus de points ?</MorePointsButton>
          </DarkSection>
        </>
      )}
    </>
  );
};

GiftsBlock.propTypes = {
  data: PropTypes.array,
  userPoints: PropTypes.number,
};

export default GiftsBlock |> query('getGifts', {loadingFullWidth: true});
